import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { BcAnalytics } from 'common/analytics/analytics.service';
import * as moment from 'moment';
import { Email } from './models/email.interface';
import { UserContextService } from 'common/user-context/user-context.service';

@Component({
  selector: 'app-email-viewer',
  templateUrl: './email-viewer.component.html',
  styleUrls: ['./email-viewer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EmailViewerComponent {
  public moment;
  public detailsExpanded;

  @Input()
  email: Email;

  @Output()
  bodyLoaded: EventEmitter<void> = new EventEmitter();

  constructor(private _bcAnalytics: BcAnalytics, private _userContextService: UserContextService) {
    this.moment = moment;
    this.detailsExpanded = false;
  }

  get emailId() {
    return this.email.id;
  }

  get emailBody() {
    return this.email.html || `<pre>${this.email.body}</pre>`;
  }

  get redirectUrl() {
    return `/emails/index.html#${this.emailId}&${this._userContextService.userContext.accountId}`;
  }

  toggleDetails() {
    this.detailsExpanded = !this.detailsExpanded;
  }

  trackOpenEmailInNewWindow() {
    this._bcAnalytics.eventTrack('EmailInNewWindow');
  }
}
